import { render } from "./Graph.vue?vue&type=template&id=72fc6900&ts=true"
import script from "./Graph.vue?vue&type=script&lang=ts"
export * from "./Graph.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/chronicle/chronicle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__